<template>
  <div class="container">
    <div class="result">
      <h2>报名成功</h2>
      <p>您已报名成功，请准时来参加！</p>
      <router-link :to="{ path: '/educational/queryResule', query: { id: $route.params.id } }">
        <van-button color="#C2AD8D" text="查看我的报名" />
      </router-link>
      <div class="tip">
        <van-divider dashed hairline :style="{ borderColor: '#F3E6DD', margin: '0' }" />
        <span>*注意：如果三次未签到，您将无法报名本年度其他活动</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VolunteerSignResult'
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background: #C2AD8D url(../../../assets/wenwu@2x.png) no-repeat top right / 80%;
  overflow: hidden;
  .result {
    width: 300px;
    height: 405px;
    background: #B0946A;
    border-radius: 8px;
    margin: /*300px*/300px auto 100px;
    text-align: center;
    overflow: hidden;
    position: relative;
    h2 {
      color: #f3e6dd;
      font-size: 30px;
      font-weight: bold;
      margin-top: 126px;
    }
    p {
      color: #d9c7bb;
      font-size: 14px;
      font-weight: 500;
    }
    .tip {
      width: 100%;
      position: absolute;
      bottom: 0;
      font-size: 12px;
      font-weight: 400;
      color: #F3E6DD;
      span {
        display: block;
        margin: 10px 0;
      }
    }
    .van-button {
      min-width: 200px;
      height: 40px;
      border-radius: 7px;
      margin-top: 80px;
    }
  }
}
</style>
